import { Component, OnInit, inject } from '@angular/core';
import { FileList } from '../../shared/components/file-list/file-list';
import { Data } from '../../core/services/data';
import { FileItem } from '../../core/models/file';

@Component({
  selector: 'app-ausschreibungen',
  standalone: true,
  imports: [FileList],
  templateUrl: './ausschreibungen.html',
  styleUrl: './ausschreibungen.css'
})
export class Ausschreibungen implements OnInit {
  private dataService = inject(Data);

  files: FileItem[] = [];
  isLoading = true;
  error: string | null = null;
  downloadPath = 'ausschreibungen/';

  ngOnInit() {
    this.loadFiles();
  }

  loadFiles() {
    this.isLoading = true;
    this.error = null;

    this.dataService.getAusschreibungen().subscribe({
      next: (data) => {
        this.files = data;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading files:', err);
        this.error = 'Fehler beim Laden der Dateien';
        this.isLoading = false;
      }
    });
  }
}
